module.exports = __webpack_public_path__ + "img/hr-H-B-3-unload-connect-shadow.e6066e2a.png";